// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AccountFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AccountFilledIcon" ref={forwardedRef} {...props}>
      <path d="M9.994 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8" />
      <path d="M5.502 11.5a1.5 1.5 0 0 0-1.5 1.5v5h11.996v-5a1.5 1.5 0 0 0-1.5-1.5z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const AccountFilledIcon = /* @__PURE__ */ Object.assign(
  AccountFilledIconComponent,
  { displayName: 'AccountFilledIcon' },
);
